export interface Special {
  /** Package slug this offer applies to (matches data/packages.ts), if any. */
  packageSlug?: string;
  service: string;
  amount: string;
  appliesTo: string;
  condition?: string;
  path: string;
  linkLabel: string;
}

/** Current Mike's Pro Detail offers. */
export const specials: Special[] = [{
  packageSlug: 'full-detail',
  service: 'Full Details',
  amount: '$50',
  appliesTo: 'Off the listed price — $300 SM/Mid · $350 SUV/Cross',
  path: '/full-detail',
  linkLabel: 'View Full Detail'
}, {
  packageSlug: 'wash-wax',
  service: 'Wash & Wax',
  amount: '$20',
  appliesTo: 'Off the listed price — $160 SM/Mid · $180 SUV/Cross',
  path: '/wash-wax',
  linkLabel: 'View Wash & Wax'
}, {
  packageSlug: 'basic-wash',
  service: 'Basic Wash',
  amount: '$10',
  appliesTo: 'Off the listed price — $90 SM/Mid · $105 SUV/Cross',
  condition: '2 car minimum on Basic Wash only',
  path: '/basic-wash',
  linkLabel: 'View Basic Wash'
}, {
  service: 'Engine Cleaning',
  amount: '$40',
  appliesTo: 'Off engine bay cleaning — Engine Bay Top listed at $120',
  path: '/services/engine-bay-detailing',
  linkLabel: 'View Engine Bay Detailing'
}];
